module.exports = __webpack_public_path__ + "static/media/elegir_x.4deae7de.svg";